<template>
  <q-list
    dense
    padding
    class="detail-content"
  >
    <detail-item
      without-icon
      without-name
      class="q-mb-md"
    >
      <profile-image
        :profile-image="user.profile_image"
        :initials="user.initials"
        :color="user.color"
        :master="user.created_company"
        size="75px"
      />
    </detail-item>

    <!-- Name -->
    <detail-item
      name="Name"
      icon="mdi-account"
      :value="user.name"
    />

    <!-- Email -->
    <detail-item
      icon="mdi-email"
      name="Email Address"
    >
      <basic-link @click="goToEmail(user.email)">
        {{ user.email }}
        <span v-if="user.is_unverified" class="text-bold text-red-7">
          (Unverified)
        </span>
      </basic-link>
      <basic-link
        v-if="user.unverified_email"
        class="q-mt-md"
        @click="goToEmail(user.unverified_email.email)"
      >
        {{ user.unverified_email.email }} <span class="text-bold text-black">(Verification pending)</span>
      </basic-link>
    </detail-item>

    <!-- Phone -->
    <detail-item
      v-if="user.phone"
      icon="mdi-phone"
      name="Contact Number"
    >
      <basic-link @click="goToPhone(user.phone.full_phone)">
        {{ user.phone.full_phone }}
      </basic-link>
    </detail-item>

    <!-- Roles -->
    <detail-item
      v-if="canEdit && user.roles.length > 0"
      :with-input="29"
      icon="mdi-account-check"
      name="Roles"
    >
      <div
        class="flex q-gutter-sm"
      >
        <q-chip
          v-for="(role, key) in user.roles"
          :key="key"
          class="bg-grey-3"
          square
        >
          {{ role }}
        </q-chip>
      </div>
    </detail-item>

    <!-- Timeline -->
    <detail-item
      v-if="can(permissions.canManageUsers)"
      ref="timelineContainer"
      icon="mdi-clipboard-file-outline"
      name="Notes & Files"
      sticky
      with-input
      :sticky-top="86"
    >
      <simple-timeline
        ref="timeline"
        simple-note
        :timeline="timeline"
        :read-only="!canEdit"
        :hide-no-entries-text="canEdit"
        @add-note="(note, done) => baseAddNote(note, done, user.id, timeline)"
        @update-note="(note, done) => baseUpdateNote(note, done)"
        @remove-note="(entryId, reference) => baseRemoveNote(entryId, reference)"
        @pin-note="(entryId, val, done, reference) => basePinNote(entryId, val, done, reference)"
        @save-attachments="(keepIds, removeObjs, done) => baseSaveAttachments(keepIds, removeObjs, done, user.id, timeline)"
        @remove-attachment="(entryId, key, reference) => baseRemoveAttachment(entryId, key, user.id, reference)"
        @pin-attachment="(entryId, val, key, done, reference) => basePinAttachment(entryId, val, key, done, user.id, reference)"
      />
    </detail-item>

    <!-- Created -->
    <detail-item
      icon="mdi-content-duplicate"
      name="Created On"
    >
      <q-item-label>{{ $formatSystemDate(user.created_at, luxonFormats.FRIENDLY_DATE) }}</q-item-label>
    </detail-item>
  </q-list>
</template>

<script>
import staffTimelineMethodsMixin from 'components/app/staff/partials/mixins/staffTimelineMethodsMixin'

export default {
  mixins: [staffTimelineMethodsMixin],
  props: {
    user: {
      required: true,
      type: Object
    },
    timeline: {
      type: Array,
      default: () => {
        return []
      }
    },
    canEdit: {
      type: Boolean,
      default: false
    },
    isArchived: {
      type: Boolean,
      default: false
    }
  }
}
</script>
